export default function ContactMessage() {
    return <h1> Merci pour votre message ! </h1>;
  }
  